
<div
  class="ig-login-bg flex justify-center items-center h-screen bg-[url('https://iti-images.s3.us-east-1.amazonaws.com/imgs/login-bg1.jpeg')] bg-cover bg-center bg-no-repeat">
  <div class="min-h-screen text-gray-700 w-[900px] flex items-center justify-center">
    <div class="bg-white bg-opacity-60 backdrop-blur-lg shadow-lg p-8 rounded-2xl w-[480px]">
      <div class="flex justify-center items-center mb-6">
        <img class="w-1/2" alt="logo" src="https://iti-images.s3.us-east-1.amazonaws.com/imgs/FINAL-newLogo-ITI-2019-2048x494-1-1536x371.png" width="100">
      </div>

      <h3 class="text-gray-600 text-center">DIGITAL EXPERIENCE PLATFORM (DXP) 3.0</h3>
      <p class="text-gray-600 !mt-2 !mb-6 text-center text-sm">
        Manage website content with ease. Publish events, business listings and create itineraries using the power of
        dynamic
        content.
      </p>

      <form class="login-form" ngForm="loginFormGroup" method="post">
        <div class="my-4">
          <label class="block text-gray-600 text-sm mb-1">Account Name</label>
          <div class="flex items-center bg-white border border-gray-300 rounded-lg py-2 px-3">
            <span class="text-gray-400 mr-2">👤</span>
            <input id="username" type="text" [(ngModel)]="credentials.userName" name="username" autocomplete="username"
              class="w-full h-8 focus:outline-none" placeholder="Account Name" (keydown.enter)="login()">
          </div>
        </div>

        <div class="mb-6">
          <label class="block text-gray-600 text-sm mb-1">Password</label>
          <div class="flex items-center bg-white border border-gray-300 rounded-lg py-2 px-3">
            <span class="text-gray-400 mr-2">🔑</span>
            <input id="password" type="password" [(ngModel)]="credentials.password" name="password"
              autocomplete="current-password" class="w-full h-8 focus:outline-none" placeholder="Password"
              (keydown.enter)="login()">
          </div>
        </div>

        <ig-button #loginBtn class="flex items-center justify-center w-full text-white overflow-hidden p-1"
          cls="w-full !h-12 !rounded-[24px] flex justify-center" [isAsync]="true" (trigger)="login($event)">
          LOGIN
        </ig-button>
        <div class="flex items-center justify-center mt-1 text-sm text-red-500">{{accountStatus}}</div>

        <a class="flex items-center justify-center w-full mt-4 text-xs text-gray-600" target="_blank"
          href="https://itidigital.freshdesk.com/support/tickets/new">
          Forgot password?<span class="underline ml-2">Contact our team</span>
        </a>
      </form>
    </div>
  </div>
</div>